import { EVENT_ID_PARAM_KEY } from '../helpers/searchParams'
import { useSearchParam } from './useSearchParam'

export const useEventIdParam = () => useSearchParam(EVENT_ID_PARAM_KEY)
